import React from "react";
import "./CoursesSection.css";
import Common_Title from "../../common_components/common_title/Common_Title";

function CoursesSection() {
  const data = [
    {
      label: <>UG <br/> COURSES</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_1.png",
    },
    {
      label: <>PG <br/>COURSES</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_2.png",
    },
    {
      label: <>EXECUTIVE <br/> COURSES</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_3.png",
    },
    {
      label: <>SKILL BASED <br/>CERTIFICATIONS</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_4.png",
    },
    {
      label: <>PHD‘S / <br/> DOCTORATE</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_5.png",
    },
    {
      label: <>Guaranteed <br/> Placements</>,
      img: "/assets/images/check_your_fit/profcmya_Courses/img_6.png",
    },
  ];

  return (
    <div className="cyf_courses_section">
      <div className="container">
        <div className="title_holder">
          <Common_Title
            simpleText="Profcymya Courses &  "
            darkText="100+ Universities/Edtechs"
          />

          <p>
            <b>Your single source for a wide variety of online courses. </b>
          </p>
        </div>

        <div className="cyf_course_icons">
          <div className="row">
            {data?.map((item) => {
              return (
                <div className="col-xl-2 col-lg-3 col-md-2 col-6">
                  <div className="card_holder_content_holder">
                    <div className="img_holder">
                      <img
                        className="card_img_box"
                        src={process.env.PUBLIC_URL + item?.img}
                        alt="card img"
                      />
                    </div>

                    <div className="text_holder">
                      <p>{item?.label}</p>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* <div className="col-md-2 col-6">
              <div className="card_holder_content_holder">
                <div className="img_holder">
                  <img
                    className="card_img_box"
                    src="/assets/images/check_your_fit/profcmya_Courses/img_2.png"
                    alt="card img"
                  />
                </div>

                <div className="text_holder">
                  <p>UG COURSES</p>
                </div>
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="card_holder_content_holder">
                <div className="img_holder">
                  <img
                    className="card_img_box"
                    src="/assets/images/check_your_fit/profcmya_Courses/img_3.png"
                    alt="card img"
                  />
                </div>

                <div className="text_holder">
                  <p>UG COURSES</p>
                </div>
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="card_holder_content_holder">
                <div className="img_holder">
                  <img
                    className="card_img_box"
                    src="/assets/images/check_your_fit/profcmya_Courses/img_4.png"
                    alt="card img"
                  />
                </div>

                <div className="text_holder">
                  <p>UG COURSES</p>
                </div>
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="card_holder_content_holder">
                <div className="img_holder">
                  <img
                    className="card_img_box"
                    src="/assets/images/check_your_fit/profcmya_Courses/img_5.png"
                    alt="card img"
                  />
                </div>

                <div className="text_holder">
                  <p>UG COURSES</p>
                </div>
              </div>
            </div>

            <div className="col-md-2 col-6">
              <div className="card_holder_content_holder">
                <div className="img_holder">
                  <img
                    className="card_img_box"
                    src="/assets/images/check_your_fit/profcmya_Courses/img_6.png"
                    alt="card img"
                  />
                </div>

                <div className="text_holder">
                  <p>UG COURSES</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CoursesSection;
